import vuexStore from "@/store/customSaveStore";
import { storageRecommendation } from "../../recommendation/storage/store";

export const datasourceElectronicStorage = vuexStore({
  namespaced: true,
  path: "/datasource-electronic-storage",
  state: {
    editedDatasource: null,
    // TKP-74: veri kartından girilen kayıt düğüme bağlanır (kaynak yok)
    editedProcessData: null,
    editedElectronicStorage: null,
    ...storageRecommendation.state,
  },
  getters: {
    editedDatasource: (state) => state.editedDatasource,
    editedProcessData: (state) => state.editedProcessData,
    editedElectronicStorage: (state) => state.editedElectronicStorage,
    ...storageRecommendation.getters,
  },
  mutations: {
    editedDatasource: (state, value) => (state.editedDatasource = value),
    editedProcessData: (state, value) => (state.editedProcessData = value),
    editedElectronicStorage: (state, value) => (state.editedElectronicStorage = value),
    ...storageRecommendation.mutations,
  },
  actions: {
    ...storageRecommendation.actions,
  },
});

export const organizationElectronicStorage = vuexStore({
  namespaced: true,
  path: "/electronic-storage",
});
